import Icon from '../components/Icon.vue'

Icon.register({
  'crop-alt': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M488 352c13.3 0 24 10.7 24 24v48c0 13.3-10.8 24-24 24h-40v40c0 13.3-10.8 24-24 24h-48c-13.3 0-24-10.8-24-24v-328h-160v-96h224c17.7 0 32 14.3 32 32v256h40zM160 24v328h160v96h-224c-17.7 0-32-14.3-32-32v-256h-40c-13.3 0-24-10.8-24-24v-48c0-13.3 10.8-24 24-24h40v-40c0-13.3 10.8-24 24-24h48c13.3 0 24 10.7 24 24z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/crop-alt.js
// module id = 1242
// module chunks = 0